// src/features/assessment/data/index.ts

import { AssessmentResult } from '../engine/types';
import { CREATOR_RESULTS } from './results.creator';
import { TRANSFORMER_RESULTS } from './results.transformer';
import { BUILDER_RESULTS } from './results.builder';

// Merge all results into one big database
export const RESULTS_DB: Record<string, AssessmentResult> = {
  ...CREATOR_RESULTS,
  ...TRANSFORMER_RESULTS,
  ...BUILDER_RESULTS,
};

// Helper to safely get a result by ID
export const getAssessmentResult = (id: string): AssessmentResult | null => {
  return RESULTS_DB[id] || null;
};

// Re-export types for convenience
export * from '../engine/types';
export * from './questions';